import styled from 'styled-components/macro';

export const StyledHeaderExtra = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;
